module.exports = __webpack_public_path__ + "static/firewall-82782d1fb3b56ff156ca6ad429a98eeb.png";